import { Col, Modal, Row } from "antd";
import Decimal from "decimal.js";
import { useEffect, useState } from "react";

export default function SpecialCategoryModal({
  isModalOpen,
  setIsModalOpen,
  stagedPlates,
  setStagedPlates,
  modalSubCategories,
  selectedPlateIndex,
  selectedItemKey,
  selectedSubCategory,
  setSelectedItemKey,
  setSelectedSubCategory,
  setPlates,
}) {
  const [selectedNoodle, setSelectedNoodle] = useState(null);

  useEffect(() => {
    if (isModalOpen) {
      const preSelectedNoodle = modalSubCategories.find((item) =>
        selectedSubCategory?.includes(item.label)
      );

      setSelectedNoodle(preSelectedNoodle || null);
    }
  }, [isModalOpen, selectedSubCategory, modalSubCategories]);

  const onCancel = () => {
    const cloned_staged_plates = JSON.parse(JSON.stringify(stagedPlates));
    if (selectedItemKey) {
      cloned_staged_plates[selectedPlateIndex].items = cloned_staged_plates[
        selectedPlateIndex
      ].items.filter((item) => item.key !== selectedItemKey);
      setStagedPlates(cloned_staged_plates);
    }

    setSelectedItemKey(null);
    setSelectedSubCategory(null);
    setIsModalOpen(false);
  };

  const onSubmit = () => {
    const cloned_staged_plates = JSON.parse(JSON.stringify(stagedPlates));

    const itemToUpdate = cloned_staged_plates[selectedPlateIndex].items.find(
      (item) => item.key === selectedItemKey
    );
    if (itemToUpdate && selectedNoodle) {
      const new_sub_category = `${itemToUpdate.sub_category} + ${selectedNoodle.label}`;
      const current_price = new Decimal(itemToUpdate.unit_price);
      const added_price = new Decimal(selectedNoodle.unit_price);
      const new_unit_price = current_price.plus(added_price).toNumber();

      Object.assign(itemToUpdate, {
        sub_category: new_sub_category,
        unit_price: new_unit_price,
      });
      setPlates(cloned_staged_plates);
    }
    setSelectedItemKey(null);
    setSelectedSubCategory(null);
    setIsModalOpen(false);
  };

  return (
    <Modal
      open={isModalOpen}
      onOk={onSubmit}
      onCancel={onCancel}
      centered
      title="Select a type of noodle:"
    >
      <Row
        gutter={[16, 16]}
        style={{ height: "100%", width: "100%" }}
        justify="center"
      >
        {modalSubCategories.map((sub_cat) => (
          <Col key={sub_cat.label} span={12}>
            <div
              key={sub_cat.label}
              className={
                sub_cat.label === selectedNoodle?.label
                  ? sub_cat.is_common
                    ? "selected-common-sub-cat-btn"
                    : "selected-sub-cat-btn"
                  : sub_cat.is_common
                    ? "common-sub-cat-btn"
                    : "sub-cat-btn"
              }
              style={{
                textAlign: "center",
                padding: "0 6px",
              }}
              onClick={() => setSelectedNoodle(sub_cat)}
            >
              <span className="cat-label">{sub_cat.label}</span>
              <span className="unit-price">
                RM {sub_cat.unit_price.toFixed(2)}
              </span>
            </div>
          </Col>
        ))}
      </Row>
    </Modal>
  );
}
